import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { otListItemVariant, type OtListItemVariant } from '@1trading/design-system';
import { type PropType } from 'vue';

import { capIsNativePlatform } from '@exchange/libs/utils/capacitor/src';

import { nativeOpenLink } from './link-external-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'XListItem',
  props: {
  active: { type: Boolean, default: false } /** Whether the list item is active */,
  emitId: { type: String, required: false } /** custom identifier of the element; if provided, will be used when emitting click event */,
  href: { type: String, required: false } /** External link to navigate to on click */,
  id: { type: String, default: () => `x-list-item-${crypto.randomUUID()}` } /** element id */,
  leftIconInfo: { type: Boolean, required: false } /** Whether to show info on the left icon */,
  leftIconInheritFill: { type: Boolean, default: false } /** Allow using font color as fill color for left icon */,
  leftIconInheritStroke: { type: Boolean, default: false } /** Allow using font color as stroke color for left icon */,
  leftIconName: { type: String, required: false } /** Name of the left icon */,
  leftIconVariant: { type: String as PropType<'default' | 'flag' | 'logo' | 'error' | 'warning'>, default: 'default' } /** Variant of the left icon */,
  leftIconWarning: { type: Boolean, default: false } /** Whether to show warning on the left icon */,
  routerLink: { type: [String, Object], required: false } /** Router link to navigate to on click */,
  subtitle: { type: String, required: false } /** Subtitle */,
  title: { type: String, required: false } /** Title */,
  useSystemBrowser: { type: Boolean, default: false } /**  Native only: Use in conjunction with href to determine whether system or in-app browser is used. Ignored on web. */,
  variant: { type: String as PropType<OtListItemVariant>, default: otListItemVariant.default } /** Variant of the component */,
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const isNative = capIsNativePlatform();

const cdn = process.env.VUE_APP_CDN;

const onNativeOpenLink = () => {
  if (props.href && isNative) {
    nativeOpenLink(props.href, props.useSystemBrowser);
  }
};
const onClick = (e: string | undefined | PointerEvent) => {
  emit('click', e);
};

return (_ctx: any,_cache: any) => {
  const _component_ot_list_item = _resolveComponent("ot-list-item")!

  return (_openBlock(), _createBlock(_component_ot_list_item, {
    id: __props.id,
    class: "x-list-item",
    "is-native": _unref(isNative),
    active: __props.active,
    "emit-id": __props.emitId,
    href: __props.href,
    "left-icon-info": __props.leftIconInfo,
    "left-icon-inherit-fill": __props.leftIconInheritFill,
    "left-icon-name": __props.leftIconName,
    "left-icon-variant": __props.leftIconVariant,
    "left-icon-warning": __props.leftIconWarning,
    cdn: _unref(cdn),
    "router-link": __props.routerLink,
    subtitle: __props.subtitle,
    title: __props.title,
    variant: __props.variant,
    onClick: onClick,
    onNativeOpenLink: onNativeOpenLink
  }, _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
        ])
      }
    })
  ]), 1032, ["id", "is-native", "active", "emit-id", "href", "left-icon-info", "left-icon-inherit-fill", "left-icon-name", "left-icon-variant", "left-icon-warning", "cdn", "router-link", "subtitle", "title", "variant"]))
}
}

})